// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "gf/css/" + chunkId + "." + "b25f24258483ae656d0f" + ".css";
};